// Tenants whose newness dial behaves as a staged "story playhead" (an as-of
// rewind driving the pane-2 chronology + cumulative sidebar counts) instead of a
// live lookback window. This is the DEMO tenant and KEN (Ken's demo tool).
//
// MOVU — and every other real tenant — is deliberately NOT here, so its slider,
// counter, and chronology behaviour is byte-for-byte unchanged. Keep this set in
// sync with settings.PLAYHEAD_CLIENT_CODES on the backend.
export function isPlayheadTenant(code: string | null | undefined): boolean {
  const c = (code || '').toUpperCase()
  return c === 'DEMO' || c === 'KEN'
}
